module.exports = __webpack_public_path__ + "img/picture4.74229ec8.jpg";